import { Route, Routes } from "react-router-dom";
import Homepage from "./Pages/Homepage";
import DemoPage from "./Pages/DemoPage";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
        <Route path="/Demo/:id" element={<DemoPage />}></Route>
      </Routes>
    </div>
  );
}

export default App;
